import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-image-party',
  templateUrl: './header-image-party.component.html',
  styleUrls: ['./header-image-party.component.css']
})
export class HeaderImagePartyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
